export var GoogleTypes;
(function (GoogleTypes) {
    GoogleTypes["SublocalityLevel1"] = "sublocality_level_1";
    GoogleTypes["Locality"] = "locality";
    GoogleTypes["AdministrativeAreaLevel1"] = "administrative_area_level_1";
    GoogleTypes["PostalCode"] = "postal_code";
})(GoogleTypes || (GoogleTypes = {}));
